export const PERMISSION_ID_POLICY_UPDATE_202403 = 603;
